import Image from 'next/image'
import { FC } from 'react'
import { Wallet, GradingReport, returns, Gift } from '@components/yadav/icons'
import FastShipping from '@components/icons/FastShipping.svg'
import orderAndFinancing2 from '@publicAssets/images/ui/orderAndFinancing2.webp'
import AffirmPrice from '@components/yadav/common/Affirm/AffirmPrice'

interface OrderAndFinancingProps {
  price: number
}

const OrderAndFinancing: FC<OrderAndFinancingProps> = ({ price }) => {
  return (
    <div className="flex flex-col gap-5 lg:flex-row lg:justify-center">
      {/* Order benefits */}
      <div className="flex flex-col md:flex-row px-6 pb-6 bg-accent-2 gap-8 md:px-0 md:pb-0 md:items-center lg:basis-[830px] xl:gap-16 xl:items-start">
        <div className="relative w-full md:max-w-[422px] h-[415px] lg:w-[422px]">
          <Image
            src={orderAndFinancing2}
            alt="Order and financing"
            objectFit="cover"
            layout="fill"
            loading="lazy"
            blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII="
          />
        </div>
        <div className="lg:pr-8 xl:pt-[94px]">
          <span className="text-base font-bold whitespace-nowrap">
            What’s Included In Your order
          </span>
          <ul className="flex flex-col gap-4 mt-4">
            <li className="flex flex-row items-center gap-4">
              <Image
                src={GradingReport}
                alt="Grading report"
                width={24}
                height={24}
              />
              <span className="text-sm lg:text-base text-gray-dark whitespace-nowrap">
                Grading Report
              </span>
            </li>
            <li className="flex flex-row items-center gap-4">
              <Wallet />
              <span className="text-sm lg:text-base text-gray-dark whitespace-nowrap">
                30 Days Money Back Guarantee
              </span>
            </li>
            <li className="flex flex-row items-center gap-4">
              <Image
                src={FastShipping}
                alt="Fast shipping"
                width={24}
                height={24}
              />
              <span className="text-sm lg:text-base text-gray-dark whitespace-nowrap">
                Free Shipping
              </span>
            </li>
            <li className="flex flex-row items-center gap-4">
              <Image src={returns} alt="Returns" width={24} height={24} />
              <span className="text-sm lg:text-base text-gray-dark whitespace-nowrap">
                Free Returns
              </span>
            </li>
            <li className="flex flex-row items-center gap-4">
              <Gift />
              <span className="text-sm lg:text-base text-gray-dark whitespace-nowrap">
                Free Gift Packaging
              </span>
            </li>
          </ul>
        </div>
      </div>
      {/* Financing benefits */}
      <div className="flex flex-col w-full bg-accent-2 p-6 lg:py-0 lg:justify-center lg:basis-[600px] xl:px-16">
        <ul className="flex flex-col gap-6 md:flex-row md:gap-12 lg:flex-col lg:gap-6">
          <li>
            <span className="block text-base font-bold mb-3">
              Flexible Financing
            </span>
            <span className="block text-sm text-gray-dark lg:text-base">
              We Offer An Easy And Affordable Financing Plan To Help You <br />
              Buy A Ring He/She Will Cherish Forever. Call 1-888-968-8810 <br />
              To Learn More And Apply.
            </span>
            <AffirmPrice price={Number(price)} />
          </li>
          <li>
            <span className="block text-base font-bold mb-3">
              Earliest Delivery Date
            </span>
            <span className="block text-sm text-gray-dark lg:text-base">
              Shipped in 15 to 20 business days.
            </span>
          </li>
        </ul>
      </div>
    </div>
  )
}

export default OrderAndFinancing
